import { FC, useContext } from "react";
import { Stack, Box } from "@mantine/core";
import { CenteredLoader } from "../../../../Components/CenteredLoader";
import { CompetitionContext } from "../../../../CompetitionContext.tsx";
import { useCompetition } from "../../../../hooks/useCompetition.ts";
import { useGameList } from "../../../../hooks/useGameList.ts";
import { GameList } from "../Widgets/GameList";
import { PageTitle } from "../../../../Components/PageTitle";
import { SectionTitle } from "../../../../Components/SectionTitle";
import { IconCalendar } from "@tabler/icons-react";
import { CardContainer } from "../../../../Components/CardContainer";
import { getPresentationParamsForOrigin } from "../../../../getPresentationParamsForOrigin.ts";

export const GamesPage: FC = () => {
  const competitionId = useContext(CompetitionContext);
  const competition = useCompetition(competitionId);
  const games = useGameList(competitionId);

  const gamesWithoutMatchday =
    games.data?.games.filter((g) => !g.matchdayId) ?? [];
  const gamesWithMatchday =
    games.data?.games.filter((g) => !!g.matchdayId) ?? [];

  return (
    <Stack gap="lg" mt="md">
      <PageTitle
        icon={<IconCalendar size={24} />}
        metaDescription={`Spielplan und Ergebnisse aller Spiele beim ${getPresentationParamsForOrigin().competitionName}.`}
      >
        Alle Spiele
      </PageTitle>

      {games.isSuccess && competition.isSuccess ? (
        <Stack gap="lg">
          {gamesWithoutMatchday.length > 0 && (
            <CardContainer p="xs">
              <GameList games={gamesWithoutMatchday} />
            </CardContainer>
          )}
          {competition.data.matchdays.map((m) => {
            const matchdayGames = gamesWithMatchday.filter(
              (g) => g.matchdayId == m.id,
            );
            if (matchdayGames.length === 0) return null;
            return (
              <Box key={m.id}>
                <Box mb="xs" id={`matchday-${m.name.toLowerCase()}`}>
                  <SectionTitle>{m.name}</SectionTitle>
                </Box>
                <CardContainer p="xs">
                  <GameList games={matchdayGames} />
                </CardContainer>
              </Box>
            );
          })}
        </Stack>
      ) : (
        <CenteredLoader />
      )}
    </Stack>
  );
};
